// src/services/api/CotizacionesApi.ts
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export class CotizacionesApi {
  static async crearCotizacion(idCliente: number, idUsuario: number, fechaCotizacion: string) {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/crear`, {
        IdCliente: idCliente,
        IdUsuario: idUsuario,
        FechaCotizacion: fechaCotizacion
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al crear la cotización');
    }
  }

  static async ajustarArticulos(params: {
    idCotizacion: number;
    idArticulo: number;
    cantidad: number;
    accion: 'AddAll' | 'AddArt' | 'DelAll' | 'DelArt';
  }) {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/ajustar-articulos`, params);
      return response.data;
    } catch (error) {
      throw new Error('Error al ajustar artículos');
    }
  }

  static async finalizarCotizacion(params: {
    idCotizacion: number;
    idSucursal: number;
    observacion?: string;
  }) {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/finalizar`, params);
      return response.data;
    } catch (error) {
      throw new Error('Error al finalizar la cotización');
    }
  }

  static async cancelarCotizacion(idCotizacion: number) {
    try {
      await axios.post(`${API_URL}/cotizaciones/cancelar`, { Id: idCotizacion });
      return true;
    } catch (error) {
      throw new Error('Error al cancelar la cotización');
    }
  }

  static async getCotizaciones() {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/obtener-todas`);
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener cotizaciones');
    }
  }

  static async getCotizacionById(codigoCotizacion: string) {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/informacion`, {
        codigoCotizacion
      });
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener la información de la cotización');
    }
  }

  static async enviarCotizacionPorEmail(params: {
    codigoCotizacion: string;
    emailDestino?: string;
  }): Promise<{ mensaje: string }> {
    try {
      const response = await axios.post(`${API_URL}/cotizaciones/enviar-email`, params);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError && axios.isAxiosError(error)) {
        throw new Error((error as any).response?.data?.message || 'Error al enviar la cotización por correo');
      }
      throw new Error('Error al enviar la cotización por correo');
    }
  }
}